import { render } from "./BulkAdjustmentModal.vue?vue&type=template&id=44e576a4&ts=true"
import script from "./BulkAdjustmentModal.vue?vue&type=script&lang=ts"
export * from "./BulkAdjustmentModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__